import React, { useEffect, useState } from 'react'
import { postInformacionEmpresa, postListaChequeoInsert, postSelectCambiarEstadoPaciente } from '../../../services/PaginaRuta'
import ModalErrorListaChequeo from './ModalErrorListaChequeo'
import ModalGuardarCorrectamenteListaChequeo from './ModalGuardarCorrectamenteListaChequeo'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFListaDeChequeo from './PDFListaDeChequeo'

const ConfimarListaChequeo = ({setmodalOnConfirmarListaChequeo, dataListaChequeo, user, passChildCambioDeEstado,setmodalOnListaChequeo, setmodalOnCambioEstadoIngresoSala, passDataActualizaTablaPacientes}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [loading, setloading]=useState(true)
    const [modalOnError, setmodalOnError]=useState(false)
    const [modalOnInformacionGuardaCorrectamente, setmodalOnInformacionGuardaCorrectamente]=useState(false)
    const [informacionEmpresa,setinformacionEmpresa]=useState({
        EMPCOD: "",
          EmpNit: "",
          EmpRazSoc: "",
          MCDnom: "",
          MCDpto: "",
          T2_EMPCOD: "",
  
      })
    const handleCancelarClick=()=>{
        setmodalOnConfirmarListaChequeo(false)
    }

    const handleOnclickGuardarListaChequeo=()=>{
        const guardar={
            "ProCirCod":  dataListaChequeo.ProCirCod,
            "ProEmpCod":  dataListaChequeo.ProEmpCod,
            "ProMCDpto":  dataListaChequeo.ProMCDpto,
            "nombreCompleto":   dataListaChequeo.nombreCompleto,
            "numeroDocumento":  dataListaChequeo.numeroDocumento,
            "procedimientoRealizar":  dataListaChequeo.procedimientoRealizar,
            "lateralidad": dataListaChequeo.lateralidad,
            "nombreCirujano":   dataListaChequeo.nombreCirujano,
            "fechaCirugia": dataListaChequeo.fechaCirugia,
            "fechaNacimiento":  dataListaChequeo.fechaNacimiento,
            "tipoSangre":   dataListaChequeo.tipoSangre,
            "alergias":     dataListaChequeo.alergias,
            "cualesAlergias": dataListaChequeo.cualesAlergias,
            "hipertensionArterial": dataListaChequeo.hipertensionArterial,
            "administraAntihipertensivoPrevio":  dataListaChequeo.administraAntihipertensivoPrevio,
            "diabetesMellitus": dataListaChequeo.diabetesMellitus,
            "antiCoagulado":  dataListaChequeo.antiCoagulado,
            "caida":  dataListaChequeo.caida,
            "upp":  dataListaChequeo.upp,
            "antibioticoProfilactico": dataListaChequeo.antibioticoProfilactico,
            "administracionProfilaxis":  dataListaChequeo.administracionProfilaxis,
            "fechaHoraAdministracion":  dataListaChequeo.fechaHoraAdministracion,
            "glucometria":  dataListaChequeo.glucometria,
            "seCorrigeCon":  dataListaChequeo.seCorrigeCon,
            "sintomatologiaRespiratoria": dataListaChequeo.sintomatologiaRespiratoria,
            "sintomatologiaRespiratoriaTextArea": dataListaChequeo.sintomatologiaRespiratoriaTextArea,
            "ayunoCorrecto": dataListaChequeo.ayunoCorrecto,
            "ayunoCorrectoTextArea": dataListaChequeo.ayunoCorrectoTextArea,
            "accesoVeneso": dataListaChequeo.accesoVeneso,
            "accesoVenesoTextArea": dataListaChequeo.accesoVenesoTextArea,
            "adultoCateter": dataListaChequeo.adultoCateter,
            "adultoCateterTextArea": dataListaChequeo.adultoCateterTextArea,
            "pediatricoCateter": dataListaChequeo.pediatricoCateter,
            "pediatricoCateterTextArea": dataListaChequeo.pediatricoCateterTextArea,
            "eliminacionVello": dataListaChequeo.eliminacionVello,
            "eliminacionVelloTextArea": dataListaChequeo.eliminacionVelloTextArea,
            "laboratorioPreQuirurgico": dataListaChequeo.laboratorioPreQuirurgico,
            "laboratorioPreQuirurgicoTextArea": dataListaChequeo.laboratorioPreQuirurgicoTextArea,
            "electrocardiograma": dataListaChequeo.electrocardiograma,
            "electrocardiogramaTextArea": dataListaChequeo.electrocardiogramaTextArea,
            "medicamentosAntihipertensivosOPatologias": dataListaChequeo.medicamentosAntihipertensivosOPatologias,
            "medicamentosAntihipertensivosOPatologiasTextArea":  dataListaChequeo.medicamentosAntihipertensivosOPatologiasTextArea,
            "medicamentosAnestesiologo":  dataListaChequeo.medicamentosAnestesiologo,
            "medicamentosAnestesiologoTextArea":  dataListaChequeo.medicamentosAnestesiologoTextArea,
            "cuentaConReserva":  dataListaChequeo.cuentaConReserva,
            "cuentaConReservaTextArea":  dataListaChequeo.cuentaConReservaTextArea,
            "consentimientoCirugia":  dataListaChequeo.consentimientoCirugia,
            "consentimientoCirugiaTextArea":  dataListaChequeo.consentimientoCirugiaTextArea,
            "consentimientoAnestesia":  dataListaChequeo.consentimientoAnestesia,
            "consentimientoAnestesiaTextArea":  dataListaChequeo.consentimientoAnestesiaTextArea,
            "materialOsteosintesisOInsumos":  dataListaChequeo.materialOsteosintesisOInsumos,
            "materialOsteosintesisOInsumosTextArea":  dataListaChequeo.materialOsteosintesisOInsumosTextArea,
            "reservaUCI":  dataListaChequeo.reservaUCI,
            "reservaUCITextArea":  dataListaChequeo.reservaUCITextArea,
            "pacienteUnasMaquillaje":  dataListaChequeo.pacienteUnasMaquillaje,
            "pacienteUnasMaquillajeTextArea": dataListaChequeo.pacienteUnasMaquillajeTextArea,
            "observaciones": dataListaChequeo.observaciones,
            "frecuenciaCardiaca": dataListaChequeo.frecuenciaCardiaca,
            "saturacionOxigeno": dataListaChequeo.saturacionOxigeno,
            "temperatura": dataListaChequeo.temperatura,
            "viaTemperatura": dataListaChequeo.viaTemperatura,
            "presionSistolica": dataListaChequeo.presionSistolica,
            "presionDiastolica": dataListaChequeo.presionDiastolica,
            "peso": dataListaChequeo.peso,
            "talla":dataListaChequeo.talla
        }

        
        //setmodalOnInformacionGuardaCorrectamente(true)
        setloading(false)
        postListaChequeoInsert(guardar).then((res)=>{
            setloading(true)
            //console.log(res.data,' se guardo')
            if(res.data.success){              
              setmodalOnInformacionGuardaCorrectamente(true)
              ingresoAsalaCambioEstado()
            }else{
            setmodalOnError(true)
            }
        })
        
        
    }

    const ingresoAsalaCambioEstado=()=>{
        let fecha = new Date();
        let mes = `${fecha.getMonth() + 1}`    
        if(mes.length === 1){
          mes = "0" + mes
        }
        let dia = `${fecha.getDate()}`
        if(dia.length === 1){
          dia = "0" + dia
        }
        
        const body = {
          Id_cirugia: user.ProCirCod,
          cedula_paciente: user.MPCedu,
          nombre_cirujano: user.MPNOMC,
          nombre_paciente: user.MPNOMC,
          estado_paciente: 'ingreso a sala',
          fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
          hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
        };
        //console.log(body,'TABLERO INGRESO A SALA')
      postSelectCambiarEstadoPaciente(body)      
      passChildCambioDeEstado({
              estadoPaciente:'11',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:true,
              disabledIngresoSala:true,
              disabledPreparado:false,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:true,
              disabledRealizada:true,
              disabledFacturada:true
      })
    }

    useEffect(()=>{
        const datosEmpresa={
            "EMPCOD":usuarioInfo.Empresa,
            "MCDpto":usuarioInfo.Sede
        }
        setloading(false)
        postInformacionEmpresa(datosEmpresa).then((res)=>{
            setloading(true)
            if(res.data[0]){
              setinformacionEmpresa(res.data[0])
              console.log(res.data,'datos empresaa')
            }
            
          })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Confirmar
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Esta seguro de guardar la Lista de Chequeo
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <PDFDownloadLink document={<PDFListaDeChequeo dataListaChequeo={dataListaChequeo} informacionEmpresa={informacionEmpresa}/>} fileName="ListaChequeolllllllllllllllllllll.pdf">
                <button
                type="button"
                onClick={handleOnclickGuardarListaChequeo}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                Si
                </button>
            </PDFDownloadLink>
          </div>
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }     
        {modalOnError? <ModalErrorListaChequeo setmodalOnError={setmodalOnError}/>:null}
        {modalOnInformacionGuardaCorrectamente? <ModalGuardarCorrectamenteListaChequeo setmodalOnInformacionGuardaCorrectamente={setmodalOnInformacionGuardaCorrectamente} setmodalOnConfirmarListaChequeo={setmodalOnConfirmarListaChequeo} setmodalOnListaChequeo={setmodalOnListaChequeo} setmodalOnCambioEstadoIngresoSala={setmodalOnCambioEstadoIngresoSala} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes} dataListaChequeo={dataListaChequeo}/>:null}
    </div>
  )
}

export default ConfimarListaChequeo